import { FeatureCategory } from '../types';

export const resourcesFeatures: FeatureCategory = {
  name: "Resources & Education",
  icon: "BookOpen",
  features: [
    { 
      name: "200+ Expert Articles & Guides", 
      description: "Access to over 200 expert-written articles on aging, health, safety, and caregiving topics.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Senior Care & Pro Directories", 
      description: "Comprehensive directories of senior care resources, services, and providers in your area.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "✔"
    }
  ]
};
